module.exports = __webpack_public_path__ + "static/media/xls.1aeafbdd.png";